// mirrors the server's FREE_IDEA_LIMIT (BillingService): a Free event holds this many ideas, deleted ones don't count
export const FREE_IDEA_LIMIT = 20;

/** Ideas used and the cap, or null when the event is Pro (no cap). */
export const ideaAllowance = (hackathon: { plan?: string, ideas: Array<{ archived?: boolean }> }) =>
    hackathon.plan === 'pro' ? null : { used: hackathon.ideas.filter(i => !i.archived).length, limit: FREE_IDEA_LIMIT };
